export const BUSINESS_TYPES = {
  CORPORATION: 'corp',
  LLC: 'llc'
};
